import React from 'react';
import {Box} from '@mui/material';
import ArrTooltipWrapper from '../../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {ReactComponent as InfoIcon} from '../../../../../assets/images/info-icon.svg';
import {t} from 'i18next';

// Reuse your parseHTMLTags function
let globalTestIdCounter = 0;
const parseHTMLTags = (text: string) => {
  const tokens = text.split(/(<\/?[a-z][^>\r\n]{0,1000}>)/gi).filter(Boolean);
  const result = [];
  let i = 0;

  while (i < tokens.length) {
    const token = tokens[i];

    // Handle <b> ... </b>
    if (token.startsWith('<b')) {
      const text = tokens[i + 1];
      const closeTag = tokens[i + 2];

      if (closeTag === '</b>') {
        const id = globalTestIdCounter++;
        result.push(
          <b key={id} data-testid={`export-data-header-b-${id}`}>
            {text}
          </b>
        );
        i += 3;
        continue;
      }
    }

    // Handle <a ...> ... </a>
    if (token.startsWith('<a')) {
      const openTag = token;
      const text = tokens[i + 1];
      const closeTag = tokens[i + 2];

      if (closeTag === '</a>') {
        const hrefMatch = openTag.match(/href="([^"]*)"/);
        const href = hrefMatch ? hrefMatch[1] : '#';
        const targetMatch = openTag.match(/target="([^"]*)"/);
        const target = targetMatch ? targetMatch[1] : '_self';
        const id = globalTestIdCounter++;
        result.push(
          <a
            key={id}
            href={href}
            target={target}
            rel="noreferrer"
            data-testid={`export-data-header-a-${id}`}
          >
            {text}
          </a>
        );
        i += 3;
        continue;
      }
    }

    // plain text
    result.push(token);
    i++;
  }

  return result;
};

const ExportDataHeader = () => {
  // Here we define all sections of the content
  const topPart = [
    `Using this report, you can export document metadata, workproduct for a set of documents of interest.
User can start an Export from the Reports page. In addition, the user can also start an Export from various places within the application including DocList, Assignment, Tally etc. This is analogous to Export in RPM5.`,
    `To run an Export:`,
  ];

  const userCan = [
    `Select the set of documents as Source.`,
    `Select one of the export formats (CSV, Concordance, Tab-delimited).`,
    `From the Available Objects, select and add to Selected for Export all metadata and workproduct objects that you would like to export.`,
    `Click on Run Export.`,
  ];

  const datasetStatusInfo = [
    `The report is automatically placed in the background and the user is notified upon completion of the Export.
The generated Export (CSV or DAT) can be downloaded by clicking on the notification or by using the My Background Tasks page.`,
  ];

  const additionalInfo = [
    `<b>Schedule:</b> By clicking on the calendar icon, you will able to schedule the report as one-time or schedule it with recurrence. For more details, refer the Help information on the Schedule popup window.`,
    `<b>Sharing:</b> By clicking on the Share icon, you can share an already executed report with users in your project/security group and also with non-users. For more details, refer the Help information on the Share Report popup window.`,
    `<b>Save Report:</b> You can customize the criteria for the report and the columns of the generated report and save it as a Custom Report, by clicking on the Save icon. All the specified criteria and customized columns will be retained with the saved Custom Report. You can access the saved Custom Reports on the Reporting Landing Page. For more details, refer to Help on the Save Report popup.`,
  ];

  return (
    <Box className="export-data-header">
      <ArrTooltipWrapper
        title={t('exportData.headers.Title', 'Report: Document Data Export')}
        placement="top"
        trigger={<InfoIcon className="info-icon" tabIndex={0} />}
        dialogClassName="export-data-info-dialog"
      >
        {/* Top Section */}
        {topPart.map((txt, index) => (
          <div key={index} data-testid={`export-data-top-part-div-${index}`}>
            {parseHTMLTags(txt)}
            <br data-testid={`export-data-header-br-${index}`} />
            {index !== topPart.length - 1 && (
              <br data-testid={`export-data-header-br-top--${index}`} />
            )}
          </div>
        ))}

        {/* User Can */}
        <ul data-testid={`export-data-user-can-ul`}>
          {userCan.map((item, idx) => (
            <li key={idx} data-testid={`export-data-user-can-li-${idx}`}>
              {parseHTMLTags(item)}
            </li>
          ))}
        </ul>

        {/* Dataset Info */}
        <ul data-testid={`export-data-data-set-ul-btn`}>
          {datasetStatusInfo.map((item, idx) => (
            <li key={idx} data-testid={`export-data-header-li-data-set-${idx}`}>
              {parseHTMLTags(item)}
            </li>
          ))}
        </ul>

        {/* Additional Info */}
        <ul data-testid={`export-data-additional-ul-button`}>
          {additionalInfo.map((item, idx) => (
            <li key={idx} data-testid={`export-data-additions-li-${idx}`}>
              {parseHTMLTags(item)}
            </li>
          ))}
        </ul>
      </ArrTooltipWrapper>
    </Box>
  );
};

export default ExportDataHeader;
